<!-- Right Nav buutton -->
<div class="d-grid gap-2 d-md-flex justify-content-md-end">
  <app-fusion-button [buttonType]="'grey-border grey-text text-only'" [buttonValue]="'Right nav'"(click)="openRightNav()">
  </app-fusion-button>
</div>
<app-common-screen *ngIf="sideScreen" [headerTitle]="tab?.sideNavLable" (sideScreenEmittedEvent)="sideScreen = false">
  <div class="side-main-content">
    <div class="tab-content mt-4" id="commonTabContent">
      <div *ngIf="displayedTabContent === tab.name">
        <div *ngIf="tab?.components !== undefined">
          <div class="row flex" *ngFor="let comp of tab?.components; let j=index">
            <!-- SKS5OCT24 table component -->
            <div *ngIf="comp.type === 'table'">
              <app-data-table 
                [tableId]="comp.config?.tableId"
                [searchBar]="comp.config?.searchBar" 
                [data]="comp?.config?.data"
                [tableWidth]="comp?.config?.tableWidth"
                [headerLabels]="comp.config?.headerLabels"
                [displayedColumns]="comp.config?.displayedColumns"
                [hyperLinkColumns]="comp.config?.hyperLinkColumns"
                [filterColumns]="comp.config?.filterColumns || []"
                [cumulativeDataColumns]="comp?.config?.cumulativeDataColumns"
                [multipleFilter]="comp.config?.multipleFilterArray || []" 
                [fromWhere]="comp.config?.fromWhere"
                [withCheckBox]="comp.config?.withCheckBox"
                [isEditRow]="comp.config?.isEditRow" 
                [isDeleteRow]="comp.config?.isDeleteRow"
                [actionButton]="comp.config?.actionButton"
                [isButtons]="comp.config?.isButtons"
                [buttonArray]="comp.config?.buttons"
                [addInlineRecord]="comp.config?.addInlineRecord">
              </app-data-table>
            </div>
            <!-- SKS5OCT24 card component -->
            <div *ngIf="comp.type === 'card'">
              <div class="row flex">
                <div *ngFor="let card of cardData" class="{{card.cardSize}}">
                  <div class="mt-3">
                    <div class="static-width-for-card width-100">
                      <app-cards [inlineDetailed]="true">
                        <div class="header-section flex content-space-between">
                          <span>{{card.label}}</span>
                        </div>
                        <div class="body-section card-text" [style]="card.style">
                          <div class="flex">
                            <div class="row g-3 flex w-100">
                              <div *ngFor="let detail of card.config.details" class="{{card.cardInlineSize}} mt-3 mb-3 d-flex flex-column">
                                <label class="label-head">{{detail.label}}</label>
                                <label *ngIf="detail.value; else noValue" class="label-sub">{{ detail.value }}</label>
                                <ng-template #noValue> <!-- SKS5OCT24 no value label -->
                                  <label class="label-sub">_</label>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </app-cards>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>
</app-common-screen>